var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercraft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M2.558 12.102a1.93 1.93 0 012.605-.113l.123.113 10.142 10.141a1.93 1.93 0 01-2.606 2.841l-.123-.112L2.558 14.83a1.93 1.93 0 010-2.728z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.182 1.017c1.007-.996 2.707-.34 2.806 1.026l.005.126v10.736c0 .9-.737 1.629-1.647 1.629a1.64 1.64 0 01-1.642-1.507l-.004-.122V6.1l-8.043 7.957c-1.007.995-2.707.34-2.806-1.026l-.005-.126V6.1l-8.043 7.957a1.66 1.66 0 01-2.223.095l-.105-.095a1.616 1.616 0 01-.096-2.2l.096-.104L12.328 1.017c1.007-.996 2.707-.34 2.806 1.026l.005.126v6.804l8.043-7.956z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercraft);
export default __webpack_public_path__ + "static/media/mastercraft.a98383d02483419b73487b31457b7e69.svg";
export { ForwardRef as ReactComponent };